<!--
 * @Descripttion:
 * @version:
 * @Author: Jeson
 * @Date: 2021-06-07 09:41:24
 * @LastEditors: Jeson
 * @LastEditTime: 2021-10-14 15:50:55
-->
// 购物车活动面板
<template>
    <div class="active-panel">
        <!-- 优惠券列表 -->
        <CanGetCouponList showLink />
        <!-- <buy-car-active-list activeTypeName="满减" /> -->
        <buy-car-active-list activeTypeName="返券"
                             v-if="rebateCouponsList.length"
                             :activeList="rebateCouponsList" />
        <div class="config_div">
            <div class="config_title">满赠</div>
            <div class="config_content">
                <div v-if="key<3||Ishow"
                     v-for="(item,key) in ConFigList"
                     :key="key">订单金额满（不含活动商品）{{item.Condition}}元，赠送<span v-for="(tt,k) in item.ActivityConfigPresent"
                          :key="k">{{tt.Name+tt.Amount+tt.Unit}}{{ tt.IsMustSend?'(必送)':'(选送)'}}{{k+1!=item.ActivityConfigPresent.length?'、':''}} </span><span class="flag"
                          v-if="item.isGet">已赠送</span></div>
                <div v-if="!Ishow"
                     class="more"
                     @click.stop="Ishow=true">查看更多</div>
            </div>
        </div>
    </div>
</template>
<script>
import CanGetCouponList from '@/components/CanGetCouponList.vue'
import BuyCarActiveList from './BuyCarActiveList.vue'
export default {
    name: '',
    mixins: [],
    components: { CanGetCouponList, BuyCarActiveList },
    // 数据部分
    props: {
        rebateCouponsList: {
            // 返券列表
            type: Array,
            default: () => [],
        },
        AllConfig: {
            // 满赠阶梯
            type: Array,
            default: () => [],
        },
        TotalAmount: {
            type: Number,
            default: 0
        }
    },
    data () {
        return {
            ConFigList: [],
            Ishow: false
        }
    },
    computed: {},
    watch: {
        AllConfig: {
            handler (val) {
                // if (val.length > 0) {
                //     // 处理数据-倒叙排列展示
                //     val[0].Configs.sort((x, y) => {
                //         return x.Condition < y.Condition ? -1 : ((x.Condition = y.Condition) ? 0 : 1)
                //     })
                //     let lastCondition = 0
                //     val[0].Configs.forEach(oo => {
                //         if (
                //             this.TotalAmount >= oo.Condition &&
                //             oo.Condition >= lastCondition
                //         ) {
                //             lastCondition = oo.Condition
                //         }
                //     })
                //     val[0].Configs.map(i => {
                //         if (i.Condition == lastCondition) {
                //             i.isGet = true
                //         }
                //     })
                    this.ConFigList = val[0].Configs
                // }
            },
            immediate: true,
            deep: true
        },
        TotalAmount: {
            handler (val) {
                let lastCondition = 0
                this.ConFigList.forEach(oo => {
                    oo.isGet = false
                    if (
                        val >= oo.Condition &&
                        oo.Condition >= lastCondition
                    ) {
                        lastCondition = oo.Condition
                    }
                })
                this.ConFigList.map(i => {
                    if (i.Condition == lastCondition) {
                        i.isGet = true
                    }
                })
                this.$forceUpdate()
            },
            immediate: true,
            deep: true
        },
    },
    // 生命周期
    created () {
    },
    mounted () { },
    unmounted () { },
    // 方法
    methods: {

    },
}
</script>
<style lang="less" scoped>
.active-panel {
    width: 1200px;
    // min-height: 95px;
    background: #ffeeec;
    border-radius: 2px;
    box-sizing: border-box;
    padding: 16px 20px 16px 20px;
    margin-bottom: 16px;
}
.config_div {
    display: flex;
    justify-items: center;
    .config_title {
        flex-shrink: 0;
        width: 2.67rem;
        height: 1.33rem;
        background: linear-gradient(328deg, #ff6831 0%, #f3180e 100%);
        border-radius: 0.33rem;
        margin-top: 0.2rem;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 1.33rem;
    }
    .config_content {
        padding-left: 0.67rem;
        // width: 44.58rem;
        // height: 1.17rem;
        font-size: 1.17rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #111a34;
        line-height: 1.8rem;
        text-align: left;
        .flag {
            width: 3.5rem;
            height: 1.17rem;
            font-size: 1.17rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ff3939;
            line-height: 1.17rem;
            margin-left: 1.33rem;
        }
        .more {
            width: 4rem;
            height: 1rem;
            font-size: 1rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #0f6eea;
            line-height: 1rem;
            cursor: pointer;
            margin-top: 1.33rem;
        }
    }
}
</style>
